<div class = "task-details" id="taskDetails">
    <ng-container class="task-details-content" [ngSwitch]="getComponentName()">
        <app-task-details-android *ngSwitchCase="'android'" [deviceKind]="deviceKind"></app-task-details-android>
        <app-task-details-windows *ngSwitchDefault [deviceKind]="deviceKind"></app-task-details-windows>
    </ng-container>
</div>